import { selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import { Fragment, PropsWithChildren, useEffect } from "react"
import { useHistory } from "react-router-dom"

export const TwoFactorGuard = ({ children }: PropsWithChildren) => {
  const history = useHistory()
  const { disable_totp_check, totp_enabled } = useStoreClient(selectUser)
  useEffect(() => {
    if (!disable_totp_check && !totp_enabled) {
      history.push("/settings/two-factor/register")
    }
  }, [disable_totp_check, totp_enabled, history])
  return <Fragment>{children}</Fragment>
}
